import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { ToJsonWorkflowNode } from '@blaze-shared/workflow-domain';

import { COLUMN_SOURCE_ID } from '../../errors';
import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('ToJson')
export class ToJsonNode extends BaseWorkflowNode<ToJsonWorkflowNode> {
  static readonly COLUMN_SOURCE_ID = COLUMN_SOURCE_ID;
  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [
      ...getColumnReferencesFromString(this.node.name, schemas),
      ...this.node.assignments.flatMap((assignment, i) => [
        ...getColumnReferencesFromString(
          assignment.value,
          schemas,
          ToJsonNode.COLUMN_SOURCE_ID + i,
        ),
      ]),
    ];
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [
      ...getTagReferencesFromString(this.node.name, schemas),
      ...this.node.assignments.flatMap((assignment, i) => [
        ...getTagReferencesFromString(assignment.value, schemas, ToJsonNode.COLUMN_SOURCE_ID + i),
      ]),
    ];
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [
      ...getParamReferencesFromString(this.node.name, schemas, connectors),
      ...this.node.assignments.flatMap((assignment, i) => [
        ...getParamReferencesFromString(
          assignment.value,
          schemas,
          connectors,
          ToJsonNode.COLUMN_SOURCE_ID + i,
        ),
      ]),
    ];
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [
      ...getNamedInputReferencesFromString(this.node.name, schemas),
      ...this.node.assignments.flatMap((assignment, i) => [
        ...getNamedInputReferencesFromString(
          assignment.value,
          schemas,
          ToJsonNode.COLUMN_SOURCE_ID + i,
        ),
      ]),
    ];
  }
}
